<template>
<nav class='un_itemnav'>
  <div class='cat_nav-header'>
    <p v-if='items'>Showing {{items.length}} Items:</p>
    <p v-else>Loading items...</p>
  </div>
  <div
    class='un_menuitem_container'
    :class='{vertCenter: vertCenter}'
    v-if='$route.name !== "designer-view"'>
    <Item
      v-for='item in items'
      :item='item'
      :name='item.type_of.name'
      :itemId='item.id'
      :category='item.category'
      :key='item.itemId'/>
  </div>
</nav>
</template>
<script>
import Item from './Item.vue'
import { mapState, mapActions } from 'vuex'
export default {
  props: ['env'],
  computed: {
    ...mapState('system', ['items'])
  },
  data () {
    return {
      vertCenter: true
    }
  },
  watch: {
    $route: function (value) {
      if (value) {
        if ((value.name === 'item-selection')) {
          this.getItemsByCategory(value.params.categoryId)
        }
      }
    },
    items: function (value) {
      if (value) {
        this.getFirstItem()
      }
    }
  },
  methods: {
    ...mapActions('system', ['getAllItems', 'getItemsByCategory']),
    getFirstItem () {
      if (this.$route.name === 'item-selection' && this.items) {
        this.$router.push({
          name: 'product-listing',
          params: {
            categoryId: this.$route.params.categoryId,
            itemId: this.items[0].id
          }
        })
      }
    }
  },
  mounted () {
    if ((this.$route.name === 'item-selection') || (this.$route.name === 'product-listing')) {
      this.getItemsByCategory(this.$route.params.categoryId)
      this.getFirstItem()
    } else {
      this.getAllItems()
    }
  },
  components: {
    Item
  }
}
</script>
<style lang='scss'>
.un_itemnav{
  @include full_wh;
  position:fixed;
  width:$s_globalsubnav_w;
  overflow-y:scroll;
  background-color:$c_item-nav;
  box-shadow: $shadow_gold-item-nav;
  .cat_nav-header{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 5rem;
    padding: 2rem;
    background-color:$c_item-nav;
    padding-top: 3.1rem;
    p{
      @include font-size(1.045);
      color: $c_dark_blue;
      @include type_bold;
    }
  }
  .un_menuitem_container{
    position: relative;
    margin-top:10rem;
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/gold-admin/ItemSelection.vue